export default (state = [], action) => {
	let fecha = Date.now();
	switch (action.type){
		case 'LOGIN':
			return {
				...state,
				username: action.user.username,
				logedIn: true,
				refresh_token: action.user.refresh_token,
				access_token: action.user.access_token,
				expire_time: action.user.expires_in*1000,
				switch_user: ''
			}
		case 'REFRESH_TOKEN':
			return {
				...state,
				//username: action.user.username,
				//logedIn: true,
				refresh_token: action.user.refresh_token,
				access_token: action.user.access_token,
				expire_time: action.user.expires_in*1000,
				//id: action.user.id,
				//firstName: action.user.firstName,
				//customer: action.user.customer,
				//role: action.user.role,
				//switch_user: action.user.switch_user
			}
		case 'PROFILE':
			return {
				...state,
				username: action.user.username,
				//logedIn: state.logedIn,
				//refresh_token: state.refresh_token,
				//access_token: state.access_token,
				//expire_time: state.expire_time,
				id: action.user.id,
				firstName: action.user.firstName,
				customer: action.user.customer,
				role: action.user.role,
				switchUser: typeof(action.user.switchUser !== 'undefined') ? action.user.switchUser : '',
				//switch_user: state.switch_user
			}
		case 'LOGOUT':
			return {
				...state,
				username: '',
				switch_user: '',
				logedIn: false,
				refresh_token: '',
				access_token: '',
				expire_time: '',
				id: '',
				firstName: '',
				customer: '',
				switchUser: ''
			}
		case 'SWITCH':
			return {
				...state,
				switch_user: action.current_user_username,
				username: action.new_user.username,
				logedIn: true,
				refresh_token: action.new_user.refresh_token,
				access_token: action.new_user.access_token,
				//expire_time: fecha+(action.new_user.expires_in*1000)
				expire_time: (action.new_user.expire_time*1000)
			}
		case 'SWITCH_LOGOUT':
			return {
				...state,
				username: state.switch_user,
				switch_user: '',
				logedIn: true,
				refresh_token: action.newUserToken.refresh_token,
				access_token: action.newUserToken.access_token,
				expire_time: (action.newUserToken.expire_time*1000)
			}
		default:
			return state;
	}
};